<template>
  <li class="nav-item dropdown" v-cloak>
    <a id="navbarNotifications" :class="childClassVal" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span v-if="hasUnread">
        <i class="material-icons">notifications_active</i>
        <span class="badge badge-light position-absolute" style="right: 5px;top: 5px;">{{ total }}</span>
      </span>
      <i class="material-icons" v-else>notifications_none</i>
    </a>

    <div class="dropdown-menu dropdown-menu-right py-0 notification-container" aria-labelledby="navbarNotifications" style="width: 450px; max-width: 450px;">
      <div class="dropdown-header border-bottom">
        <a href="#" @click.prevent="markAllRead" class="float-right" v-if="hasUnread">
          Marcar todo como leído
        </a>
        <h5 class="m-0">
          Notificaciones
          <span class="badge badge-secondary">{{ total }}</span>
        </h5>
      </div>
      <preloader v-if="loading"></preloader>
      <div style="max-height: calc(100vh - 250px);overflow-y: auto;">
        <div class="list-group" v-if="hasUnread">
          <notification v-for="notification in notifications"
            :key="notification.id"
            :notification="notification"
            v-on:read="markAsRead(notification)"
          ></notification>
        </div>
        <div v-else class="text-center">
          <img :src="imgNotification" alt="Notifications" class="img-fluid m-3" width="200px">
          <h5 class="text-muted text-center">No tienes notificaciones en este momento. <br>Vuelve mas tarde</h5>
        </div>

        <h5 v-if="!loading && page == 0">
          Cargando...
        </h5>
        <infinite-loading @distance="1" @infinite="infiniteHandler" spinner="spiral" ref="infiniteLoading">
          <div slot="no-more" class="text-center">
            <p class="text-muted my-2">No hay más registros</p>
          </div>
          <div slot="no-results" class="text-center">
            No hay registros
          </div>
        </infinite-loading>
      </div>
    </div>
  </li>
</template>

<script>
import Notification from './Notification';

export default {
  components: { Notification },

  props: ['user', 'child'],

  data: () => ({
    total: 0,
    notifications: [],
    page: 0,
    loading: false
  }),

  created(){
    this.listenNotifications()
  },

  mounted () {
    this.init();
    if (window.Echo) {
      this.listen();
    }

    this.initDropdown();
  },

  computed: {
    hasUnread () {
      return this.total > 0;
    },

    imgNotification(){
        return crm.url + '/images/icons/sleeping_bell.png';
    },

    childClassVal (){
      return this.child || 'nav-link'
    }
  },

  methods: {
    infiniteHandler($state) {
        this.page++
        this.loading = true
        let url = '/notifications?page='+this.page
        
        axios.get(url)
        .then(response => {
            let notifications = response.data.data
            if(notifications.length){
                this.total = response.data.total;
                this.notifications = this.notifications.concat(
                  notifications.map(({ id, data, created }) => {
                    return {
                      id: id,
                      icon: data.icon,
                      title: data.title,
                      body: data.body,
                      created: created,
                      action_url: data.action_url,
                      id_type: data.id,
                      type: data.type
                    }
                  })
                )

                $state.loaded()
            }else{
                $state.complete()
            }
        })
        .then(() => {
          this.loading = false
        })
    },

    init() {
      var vm = this
        this.page++
        this.loading = true
        let url = '/notifications?page='+this.page
        axios.get(url)
        .then(response => {
            let notifications = response.data.data
            if(notifications.length){
                this.total = response.data.total;
                this.notifications = this.notifications.concat(
                  notifications.map(({ id, data, created }) => {
                    return {
                      id: id,
                      icon: data.icon,
                      title: data.title,
                      body: data.body,
                      created: created,
                      action_url: data.action_url,
                      id_type: data.id,
                      type: data.type
                    }
                  })
                )

                vm.$nextTick(() => {
                  vm.$refs.infiniteLoading.stateChanger.loaded()
                })
            }else{
              vm.$nextTick(() => {
                  vm.$refs.infiniteLoading.stateChanger.loaded()
                })
            }
        })
        .then(() => {
          this.loading = false
        })
    },

    listenNotifications (){
      var vm = this
      vm.callNotification()
      setInterval(function(){vm.callNotification()}, 180000)
      setInterval(function(){vm.callNotificationOthersClients()}, 300000)
      //300000
    },

    callNotification(){
      axios.post('api/notifications')
        .then(response => {
          //
        })
    },

    callNotificationOthersClients(){
      /*axios.post('http://crmeasysale.com/tk/api/notifications')
        .then(response => {
          //
        })*/
    },

    /**
     * Fetch notifications.
     *
     * @param {Number} limit
     */
    fetch (limit = 5) {
      axios.get('/notifications', { params: { limit }})
        .then(({ data: { total, notifications }}) => {
          this.total = total;
          this.notifications = notifications.map(({ id, data, created }) => {
            return {
              id: id,
              icon: data.icon,
              title: data.title,
              body: data.body,
              created: created,
              action_url: data.action_url
            }
          })
        })
    },

    /**
     * Mark the given notification as read.
     *
     * @param {Object} notification
     */
    markAsRead ({ id }) {
      const index = this.notifications.findIndex(n => n.id === id);
      if (index > -1) {
        this.total--;
        this.notifications.splice(index, 1);
        axios.patch(`/notifications/${id}/read`).catch(error =>{
          console.log(error.response);
        });
      }
    },

    /**
     * Mark all notifications as read.
     */
    markAllRead () {
      this.total = 0;
      this.notifications = [];

      axios.post('/notifications/mark-all-read');
    },

    /**
     * Listen for Echo push notifications.
     */
    listen () {
      window.Echo.private(`App.Models.Usuario.${this.user}`)
        .notification((notification) => {
          this.total++;

          this.notifications.unshift(notification);
          /*const index = this.notifications.findIndex(n => n.type == notification.type && n.id_type == notification.data.id)
          if (index > -1) {
            this.notifications.splice(index, 1);
          }*/
          toastr.info(notification.body, notification.title)
        })
        .listen('NotificationRead', ({ notificationId }) => {
          this.total--;

          const index = this.notifications.findIndex(n => n.id === notificationId);
          if (index > -1) {
            this.notifications.splice(index, 1);
          }
        })
        .listen('NotificationReadAll', () => {
          this.total = 0;
          this.notifications = [];
        });
    },

    /**
     * Initialize the notifications dropdown.
     */
    initDropdown () {
      const dropdown = $(this.$refs.dropdown)

      $(document).on('click', (e) => {
        if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0 &&
          !$(e.target).parent().hasClass('notification-mark-read')) {
          dropdown.removeClass('open');
        }
      })
    },

    /**
     * Toggle the notifications dropdown.
     */
    toggleDropdown () {
      $(this.$refs.dropdown).toggleClass('open');
    }
  }
}
</script>
<style>
  @media (max-width: 576px) {
    .notification-container {
      position: fixed !important;
      left: 0px;
      right: 0px !important;
      top: 54px;
      width: 100% !important;
      max-width: 100% !important;
      float: none;
    }
  }
</style>